import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';


const LangWrapper = ({ children }) => {
    const { lng } = useParams();
    const { i18n } = useTranslation();

    useEffect(() => {
        // اگر زبان معتبر نبود → هدایت به en
        if (!['en', 'fa'].includes(lng)) {
            window.location.href = '/fa';
            return;
        }

        // تغییر زبان i18n
        i18n.changeLanguage(lng);
    }, [lng]);

    return children;
}

export default LangWrapper;